import { observer } from "mobx-react-lite"

import { Button } from "@/components/button"
import { useScaleApplication } from "@/domains/application/use-scale-application"
import { cn } from "@/domains/library"
import { PositionCard } from "@/domains/settings/components/position-card"
import { SettingsSectionLayout } from "@/domains/settings/components/settings-section-layout"
import useResponsive from "@/hooks/use-responsive"
import useEventEmitter from "@/hooks/useEventEmitter"

export const NotificationPositionSettingsSection = observer(() => {
  const emitter = useEventEmitter()
  const scaleApp = useScaleApplication()
  const { isMobile } = useResponsive()
  return (
    <SettingsSectionLayout title="Notification position" description="Choose the position of the notification">
      <div className={cn("grid w-full max-w-2xl grid-cols-5", isMobile ? "grid-cols-2 gap-6" : "")}>
        <PositionCard
          position="top-left"
          selectedPosition={scaleApp?.Settings.notificationPosition}
          setSelectedPosition={(position) => scaleApp?.Settings.setNotificationPosition(position)}
          className="order-1 sm:order-2"
        />
        <PositionCard
          position="top-right"
          selectedPosition={scaleApp?.Settings.notificationPosition}
          setSelectedPosition={(position) => scaleApp?.Settings.setNotificationPosition(position)}
          className="order-2 sm:order-3"
        />
        <PositionCard
          position="bottom-left"
          selectedPosition={scaleApp?.Settings.notificationPosition}
          setSelectedPosition={(position) => scaleApp?.Settings.setNotificationPosition(position)}
          className="order-3 sm:order-1"
        />
        <PositionCard
          position="bottom-right"
          selectedPosition={scaleApp?.Settings.notificationPosition}
          setSelectedPosition={(position) => scaleApp?.Settings.setNotificationPosition(position)}
          className="order-4 sm:order-4"
        />
        <div className="order-5 col-span-2 flex items-center justify-center sm:col-span-1">
          <Button
            variant="neutral"
            onClick={() => {
              emitter?.emit("test", {
                title: `Test`,
                description: `This is a test`,
                variant: "success",
              })
            }}
            className=" text-xs"
          >
            Test
          </Button>
        </div>
      </div>
    </SettingsSectionLayout>
  )
})
